import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const OrderMngAssigned: FC<UserTableModalProps> = ({ user, onClose, show }) => {


    console.log("user us", user)

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                    >Sale Order id</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Sale Price</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                    >Purchase Price</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                    >Qty</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                    >To Be Supplied</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                    >Company Name</th>
                                </tr>
                            </thead>
                            {/* <tbody>
                                <tr>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.assignedSaleOrders?.[0]?.saleOrderId || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.confirmedOrderDetails?.[0]?.items?.[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.assignedSaleOrders?.[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.assignedSaleOrders?.[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.assignedSaleOrders?.[0]?.remainQuantity || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody> */}




                            <tbody>
                                {user.assignedSaleOrders?.map((order, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span>
                                                {order.saleOrderId || 'N/A'}
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span>
                                                {user.confirmedOrderDetails?.[0]?.items?.[0]?.price || 'N/A'} INR/Kg
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span>
                                                {order.price || 'N/A'} INR/Kg
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span >
                                                {order.quantity || 'N/A'} Kg
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span >
                                                {order.remainQuantity || 'N/A'} Kg
                                            </span>
                                        </td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                            <span >
                                                {/* {order.companyName || 'N/A'} */}
                                                {order?.pickupPointName?.replace(', null', '') || 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>




                        </table>
                    </div>



                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};